import { ConfigProvider } from "antd"
import React, { useMemo } from "react"

import { antBreakpoints } from "../constants/breakpoint"
import { themeForAppearance } from "../theme"
import { useAppearance } from "./use-appearance"

function StaticTheme({ children }: { children: React.ReactNode }) {
  const { resolved } = useAppearance()
  const darkTheme = useMemo(() => {
    const base = themeForAppearance("dark")
    return {
      cssVar: true,
      ...base,
      token: { ...base.token, ...antBreakpoints }
    }
  }, [])
  // Light keeps antd's own defaults these popups always had.
  if (resolved !== "dark") return <>{children}</>
  return <ConfigProvider theme={darkTheme}>{children}</ConfigProvider>
}

/**
 * `Modal.confirm`, `message` and `notification` called statically render
 * outside the app's ConfigProvider, so they would stay light in dark mode.
 */
export const installStaticThemeHolder = () =>
  ConfigProvider.config({
    holderRender: (children) => <StaticTheme>{children}</StaticTheme>
  })
